class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    // this.detailsContainer.addEventListener(
    //   'keyup',
    //   (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    // );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    console.log("[SEARCH]: BUTTON: ", this.querySelector('button[type="button"]'))

    this.querySelector('button[type="button"]')?.addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
    const searchInput = this.querySelector('#voyado-search-input');
    if (searchInput) searchInput.value = '';
  }

  onBodyClick(event) {
    if (event.target.closest('[data-header-search-trigger], [data-drawer-search-trigger]')) return;

    const withinCurrentContainer = this.contains(event.target);
    const withinMiniDrawer = event.target.closest('.mini-product-drawer-drawer') !== null;
    const bodyHasDrawersOpen = document.body.classList.contains('util-DrawersOpen');
    if (!withinCurrentContainer && !withinMiniDrawer && !bodyHasDrawersOpen) this.close(false);
  }

  openFromTrigger() {
    if (this.isOpen()) return;

    const searchInput = this.querySelector('#voyado-search-input');
    if (searchInput) searchInput.value = '';

    this.open({ target: this.summaryToggle });
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.querySelector('body').style.top = `${window.scrollY}px`
    document.querySelector('body').classList.add('search-overlay')

    window.requestAnimationFrame(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    });

    const constContainer = document.querySelector('#const_container_div');
    if (constContainer) constContainer.style.display = 'none';

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    const scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
    document.body.classList.remove('search-overlay');
    document.body.style.top = '';
    if (scrollY) window.scrollTo(0, scrollY);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    const constContainer = document.querySelector('#const_container_div');
    if (constContainer) constContainer.style.display = 'block';
  }
}

if (!customElements.get('details-modal')) {
  customElements.define('details-modal', DetailsModal);
}
